import events from 'events-bus';

const sendAdobeEvent = (article, cartId, quantity, isPersonalized) => {
    const { price, shopId, psId, bestPriceArticle, sellerType } = article;
    events.post('UPDATE-ADOBE-v1', {
        price,
        quantity,
        shopId,
        psId,
        bestPriceArticle,
        cartId,
        isPersonalized,
        sellerType,
    });
};
const sendAdobeData = (eventName) => {
    if (typeof window.SendAdobeData === 'function') {
        if (window.location.href.includes('reorder') || window.location.href.includes('wishlist')) {
            window.SendAdobeData('customClickTrack', 'Account', 'ATC Popover', eventName);
        }
        else {
            window.SendAdobeData('customClickTrack', 'Catalog', 'ATC Popover', eventName);
        }
    }
};
const sendAdobeFeatureFlagData = (value) => {
    if (typeof window.addToCartPopoverDataLayer === 'undefined') {
        window.addToCartPopoverDataLayer = {
            source: 'tg',
            id: 'sc-4215_hide_chk_btn_atcp',
            value: value,
        };
    }
};

export { sendAdobeData, sendAdobeEvent, sendAdobeFeatureFlagData };
//# sourceMappingURL=adobeService.js.map
